import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import Lottie from "lottie-react";
import DoneAnimation from "../../animation/Checked.json";
import contactAnimation from "../../animation/TTA Contact Us.json";
import './contact.css';

const Contact = () => {
  const [state, handleSubmit] = useForm("xeozjknd");

  if (state.succeeded) {
    return (
      <div className="success-message" style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
        <Lottie 
          animationData={DoneAnimation} 
          style={{ height: 80, width: 80 }} 
          loop={false}
        />
        <p className="thank-you" style={{ fontSize: '18px', fontWeight: '500' }}>
          Thanks! We've received your message and will get back to you soon.
        </p>
      </div>
    );
  }

  return (
    <section className="contact-us">
      <h1 className="title">
        <span className="fa fa-envelope"></span> Contact Us
      </h1>
      <p className="sub-title">
        Contact us for more information and get notified when I publish something new.
      </p>

      <div style={{justifyContent:"space-between"}} className="flex">
        <form onSubmit={handleSubmit} className="border">
          <div className="flex">
            <label htmlFor="email">Email Address:</label>
            <input required type="email" name="email" id="email" />
            <ValidationError 
              prefix="Email" 
              field="email"
              errors={state.errors}
            />
          </div>

          <div className="flex" style={{ marginTop: "24px" }}>
            <label htmlFor="message">Your Message</label>
            <textarea required name="message" id="message"></textarea>
            <ValidationError 
              prefix="Message" 
              field="message"
              errors={state.errors}
            />
          </div>

          <button type="submit" disabled={state.submitting} className="submit">
            Submit
          </button>
        </form>

        <div className="border animation">
            <Lottie 
            className="contact-animation"
          animationData={contactAnimation} 
          style={{ height: 355}} 
         
        />
        </div>
      </div>
    </section>
  );
};

export default Contact;
